import React  from "react";
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import { useTranslation } from 'react-i18next';

export default function NeoButton({ onClick=()=>{}, type='next', label=null, disabled, children=null }) {
    const [buttonLabel, setLabel] = React.useState(label);
    const [isLoading, setLoading] = React.useState(false);
    const { t } = useTranslation();

    const variants = {
        next : 'primary',
        skip: 'dark',
        submit: 'success',
        previous: 'primary',
        cancel: 'danger',
        reset: 'secondary'
    };

    const defaultLabel = {
        next : t('widget.button.next.default_label'),
        skip: t('widget.button.skip.default_label'),
        submit: t('widget.button.submit.default_label'),
        previous: t('widget.button.previous.default_label'),
        cancel: t('widget.button.cancel.default_label'),
        reset: t('widget.button.cancel.default_label')
    };

    React.useEffect(() => {
        setLabel(label ? label : defaultLabel[type]);
    }, [defaultLabel, type, label]);

    // Creates a type=submit to auto submit forms on enter
    let buttonType = {};
    if(['next', 'submit'].includes(type)) {
        buttonType = { type: 'submit' };
    } else {
        buttonType = { type: 'button' }
    }

    const click = React.useCallback((event) => {
        setLoading(true);
        let result = onClick(event);
        if(result instanceof Promise) {
            onClick(event).finally(() => {
                setLoading(false);
            });
        } else {
            setLoading(false);
        }
    }, [onClick]);

    return (
        <Button
            variant={variants[type]}
            className={`${type} wz-neo-button`}
            onClick={click}
            disabled={disabled || isLoading}
            {...buttonType}
        >
            {!isLoading ? (children || buttonLabel) : <Spinner animation="grow" />}
        </Button>
    );
}

Button.defaultProps = {
    onClick: () => {},
    type: 'submit',
    label: null
};

Button.propTypes = {
    onClick: PropTypes.func,
    type: PropTypes.string,
    label: PropTypes.string,
};
